import React from "react";
import { apiStokRework, formatApiErrorDetail } from "@/lib/api";
import { qty } from "@/lib/format";
import { Loader2 } from "lucide-react";
import * as W from "@/lib/waktu";

const waktu = (iso) => { try { return W.waktu(iso); } catch { return iso; } };

// Owner 2026-10-08: material used again by QC reworks (waste), per period.
export default function StokRework() {
  const [f, setF] = React.useState({ dari: "", sampai: "" });
  const [d, setD] = React.useState(null);
  const [error, setError] = React.useState(null);
  const load = React.useCallback(() => {
    setError(null);
    apiStokRework(Object.fromEntries(Object.entries(f).filter(([, v]) => v))).then(setD)
      .catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail) || e.message));
  }, [f]);
  React.useEffect(() => { load(); }, [load]);
  return (
    <div data-testid="stok-rework" className="space-y-4">
      <div className="flex flex-wrap items-end gap-3 text-sm text-slate-300">
        <label>Dari <input type="date" value={f.dari} onChange={(e) => setF({ ...f, dari: e.target.value })} className="ml-1 rounded border border-slate-700 bg-slate-950 px-2 py-1" /></label>
        <label>Sampai <input type="date" value={f.sampai} onChange={(e) => setF({ ...f, sampai: e.target.value })} className="ml-1 rounded border border-slate-700 bg-slate-950 px-2 py-1" /></label>
        {d && <span className="text-xs text-slate-500">Periode {d.dari} s.d. {d.sampai}</span>}
      </div>
      {error && <p className="text-sm text-red-300">{error}</p>}
      {!d ? <p className="text-slate-400"><Loader2 className="inline animate-spin mr-2" size={16} />Memuat…</p> : (<>
        <div className="rounded-xl border border-slate-800 bg-slate-900/60 p-4">
          <h3 className="text-sm font-semibold text-slate-200 mb-2">Total bahan terbuang karena reject QC</h3>
          {d.total.length === 0 ? <p className="text-xs text-slate-500">Tidak ada rework yang memakai bahan pada periode ini.</p> : (
            <ul data-testid="stok-rework-total" className="text-sm space-y-1">{d.total.map((t) => <li key={t.bahan_id}><span className="font-mono text-amber-300">{t.kode}</span> {t.nama}: <b>{qty(t.qty_milli)}</b> {t.satuan}</li>)}</ul>)}
        </div>
        {d.mutasi.length > 0 && (
          <table className="w-full text-sm"><thead><tr className="text-left text-xs font-semibold text-slate-500 bg-slate-900 border-b border-slate-800">
            <th className="py-2">Waktu</th><th>SPK</th><th>Bahan</th><th className="text-right">Qty</th><th className="pl-3">Keterangan</th></tr></thead>
            <tbody>{d.mutasi.map((m) => (
              <tr key={m.id} className="border-b border-slate-800/60"><td className="py-1.5 text-xs text-slate-400">{waktu(m.waktu)}</td>
                <td className="font-mono text-amber-300">{m.referensi?.nomor} <span className="text-xs text-slate-500">rework ke-{m.referensi?.rework_ke}</span></td>
                <td className="font-mono">{m.bahan_kode}</td><td className="text-right">{qty(-m.qty_milli)} {m.satuan}</td>
                <td className="pl-3 text-xs text-slate-400">{m.alasan}</td></tr>))}</tbody></table>)}
      </>)}
    </div>
  );
}
